import {
  HANDLE_PROJECT_NAME,
  API_STATUS,
  HANDLE_PARAMETER_LIST,
  PROJECTS_PARAMETERS,
  INVESTIGATION_TABLE_DATA,
  FILTERD_REPORTS_DATA_LIST,
  PREVIEW_BATCH_RECORDS,
  PROJECT_NAME_API_STATUS,
  VISUALIZATION_DATA_HISTORY,
  GET_VISUALIZATION_PROJECTS,
  VISUALIZATION_SUBMIT_QUERY,
  VISUALIZATION_SUBMIT_RESULT,
  GET_VISUALIZATION_DETAILS,
  GET_FILES_FOR_PREVIEW_LIST,
  EXPORT_INVESTIGATION_DATA_API_STATUS,
  GET_TASKS_DATA,
  PRODUCT_TYPE_BATCH_NAME_USER_NAME,
  DASHBOARD_LOG_TILES_DATA,
  BATCH_NAMES,
  BATCH_TILES_DATA,
  BATCH_DOCUMENTS,
  BATCH_PARAMETERS,
  BATCH_LOGS,
  GET_PROJECTS_AND_BATCHES_WITH_STATUS_COUNTS,
  GET_DRUG_PRODUCTS,
  GET_COUNTS_PER_DRUG_PRODUCTS,
  GET_PROJECT_AND_BATCHES,
  GET_BATCH_STATUS,
  // GET_BATCH_STATUS_TILES,
  GET_BATCH_TILES_DATA,
  GET_BATCH_TILES_FILTERS_DATA,
  GET_BATCH_LOGS_FILTERS_DATA,
  GET_ALL_BATCH_TILES_API_STATUS,
  GET_ALL_PREVIOUS_REPORTS_LIST_API_STATUS,
  API_STATUS_GET_LOGS,
  GET_LOG_PDF_URL,
  INVESTIGATION_SEARCH_API_STATUS,
  DASHBOARD_TILES_API_STATUS_MASTER,
  // SUBMIT_OUT_PUT_FILE_UPLOAD,
  // REJECT_OUT_PUT_FILE_BATCH,
  API_STATUS_MASTER,
  GET_OUT_PUT_URL,
} from "./types";
import { initialState } from "./initialState";
import InvestigationService from "../../services/investigationServices";
import { errorMessage } from "../../constants/responseMessages";

const service = new InvestigationService();

export const getProjectName = () => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getProjectName()
      .then((res) => {
        dispatch({
          type: API_STATUS,
          payload: { ...initialState?.apiStatus, loader: false },
        });
        dispatch({
          type: HANDLE_PROJECT_NAME,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: { ...initialState?.apiStatus, loader: false },
        });
      });
  };
};
export const getParameterList = (projectId) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getParameterList(projectId)
      .then((res) => {
        dispatch({
          type: API_STATUS,
          payload: { ...initialState?.apiStatus, loader: false },
        });
        dispatch({
          type: HANDLE_PARAMETER_LIST,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: { ...initialState?.apiStatus, loader: false },
        });
      });
  };
};

export const clearProjectNameApiStatus = () => {
  return (dispatch) => {
    dispatch({
      type: PROJECT_NAME_API_STATUS,
      payload: {},
    });
  };
};

export const getProjectsWithParameters = () => {
  return (dispatch) => {
    dispatch({
      type: PROJECT_NAME_API_STATUS,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getProjectWithParametersName()
      .then((res) => {
        dispatch({
          type: PROJECT_NAME_API_STATUS,
          payload: { ...initialState?.apiStatus, loader: false },
        });
        dispatch({
          type: PROJECTS_PARAMETERS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: PROJECT_NAME_API_STATUS,
          payload: { ...initialState?.apiStatus, loader: false },
        });
      });
  };
};

export const getInvestigationTableData = (data) => {
  return (dispatch) => {
    dispatch({
      type: INVESTIGATION_SEARCH_API_STATUS,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getInvestigationTableData(data)
      .then((res) => {
        dispatch({
          type: INVESTIGATION_SEARCH_API_STATUS,
          payload: {
            ...initialState.apiStatus,
            loader: false,
            next: data?.next,
            apiSuccess: true,
          },
        });
        dispatch({
          type: INVESTIGATION_TABLE_DATA,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: INVESTIGATION_SEARCH_API_STATUS,
          payload: {
            ...initialState.apiStatus,
            loader: false,
            message: errorMessage(error),
            apiError: true,
          },
        });
      });
  };
};

export const getReportsData = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getReportsData(data)
      .then((res) => {
        dispatch({
          type: API_STATUS,
          payload: { ...initialState?.apiStatus, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: { ...initialState?.apiStatus, loader: false },
        });
      });
  };
};

export const getFilterationReporstList = (data) => {
  return (dispatch) => {
    dispatch({
      type: GET_ALL_PREVIOUS_REPORTS_LIST_API_STATUS,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getFilterationReporstList(data)
      .then((res) => {
        dispatch({
          type: GET_ALL_PREVIOUS_REPORTS_LIST_API_STATUS,
          payload: {
            ...initialState.apiStatus,
            loader: false,
            next: data?.next,
            apiSuccess: true,
          },
        });
        dispatch({
          type: FILTERD_REPORTS_DATA_LIST,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_ALL_PREVIOUS_REPORTS_LIST_API_STATUS,
          payload: {
            ...initialState.apiStatus,
            loader: false,
            message: errorMessage(error),
            apiError: true,
          },
        });
      });
  };
};

export const clearAllPreviousReportsApiStatus = () => {
  return (dispatch) => {
    dispatch({
      type: GET_ALL_PREVIOUS_REPORTS_LIST_API_STATUS,
      payload: { ...initialState?.apiStatus },
    });
  };
};

export const previewBatchRecords = (data) => {
  return (dispatch) => {
    service
      .previewBatchRecords(data)
      .then((res) => {
        dispatch({
          type: PREVIEW_BATCH_RECORDS,
          payload: res.data.data,
        });
      })
      .catch((error) => {});
  };
};

export const clearPreviewBatchRecords = (data) => {
  return (dispatch) => {
    dispatch({
      type: PREVIEW_BATCH_RECORDS,
      payload: "",
    });
  };
};

export const exportInvestigationDataAPiStatusClear = () => {
  return (dispatch) => {
    dispatch({
      type: EXPORT_INVESTIGATION_DATA_API_STATUS,
      payload: { ...initialState?.apiStatus },
    });
  };
};

export const exportInvestigationData = (fileName, filltersData, data) => {
  return (dispatch) => {
    dispatch({
      type: EXPORT_INVESTIGATION_DATA_API_STATUS,
      payload: { message: "", loader: true, next: false },
    });
    service
      .exportInvestigationData(fileName, filltersData, data)
      .then((res) => {
        dispatch({
          type: EXPORT_INVESTIGATION_DATA_API_STATUS,
          payload: {
            ...initialState.apiStatus,
            loading: false,
            next: true,
            message: res.data.message,
            apiSuccess: true,
            data: res?.data,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: EXPORT_INVESTIGATION_DATA_API_STATUS,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            apiError: false,
          },
        });
      });
  };
};

export const clearApiStatus = () => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus },
    });
  };
};
export const getHistoryDataForVisualization = () => {
  return (dispatch) => {
    dispatch({
      type: VISUALIZATION_DATA_HISTORY,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    dispatch({
      type: VISUALIZATION_DATA_HISTORY,
      payload: [],
    });
    service
      .getHistoryDataForVisualization()
      .then((res) => {
        dispatch({
          type: VISUALIZATION_DATA_HISTORY,
          payload: res?.data?.data,
        });
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: VISUALIZATION_DATA_HISTORY,
          payload: [],
        });
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};
export const getVisualizationProjects = () => {
  return (dispatch) => {
    dispatch({
      type: GET_VISUALIZATION_PROJECTS,
      payload: [],
    });
    service
      .getVisualizationProjects()
      .then((res) => {
        dispatch({
          type: GET_VISUALIZATION_PROJECTS,
          payload: res?.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_VISUALIZATION_PROJECTS,
          payload: [],
        });
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};
export const submitForVisualizationQuery = (data) => {
  return (dispatch) => {
    dispatch({
      type: VISUALIZATION_SUBMIT_QUERY,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .submitForVisualizationQuery(data)
      .then((res) => {
        dispatch({
          type: VISUALIZATION_SUBMIT_QUERY,
          payload: {
            ...initialState?.apiStatus,
            data: res?.data,
            message: res?.data?.message,
            loader: false,
            next: true,
            apiSuccess: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: VISUALIZATION_SUBMIT_QUERY,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};
export const submitForVisualizationResult = (data) => {
  return (dispatch) => {
    dispatch({
      type: VISUALIZATION_SUBMIT_RESULT,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .submitForVisualizationResult(data)
      .then((res) => {
        dispatch({
          type: VISUALIZATION_SUBMIT_RESULT,
          payload: {
            ...initialState?.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: true,
            apiSuccess: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: VISUALIZATION_SUBMIT_RESULT,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};
export const getVisualizationDetails = (id) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    dispatch({
      type: GET_VISUALIZATION_DETAILS,
      payload: [],
    });
    service
      .getVisualizationDetails(id)
      .then((res) => {
        dispatch({
          type: GET_VISUALIZATION_DETAILS,
          payload: res?.data?.data,
        });
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_VISUALIZATION_DETAILS,
          payload: { error: true, message: errorMessage(error) },
        });
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};
export const clearGetVisualizationDetailsResponse = () => {
  return (dispatch) => {
    dispatch({
      type: VISUALIZATION_SUBMIT_QUERY,
      payload: {},
    });
  };
};
export const clearVisualizationDetails = () => {
  return (dispatch) => {
    dispatch({
      type: GET_VISUALIZATION_DETAILS,
      payload: [],
    });
  };
};
export const getHistoryDataForVisualizationRuntime = () => {
  return (dispatch) => {
    service
      .getHistoryDataForVisualization()
      .then((res) => {
        dispatch({
          type: VISUALIZATION_DATA_HISTORY,
          payload: res?.data?.data,
        });
      })
      .catch((error) => {});
  };
};
export const clearVisualizationResultStatus = () => {
  return (dispatch) => {
    dispatch({
      type: VISUALIZATION_SUBMIT_RESULT,
      payload: {},
    });
  };
};

export const submitForRegenerateVisualizationResult = (id) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    dispatch({
      type: GET_VISUALIZATION_DETAILS,
      payload: [],
    });

    service
      .submitForRegenerateVisualizationResult(id)
      .then((res) => {
        dispatch({
          type: GET_VISUALIZATION_DETAILS,
          payload: res?.data?.data,
        });
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: res?.data?.message,
            loader: false,
            next: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_VISUALIZATION_DETAILS,
          payload: { error: true, message: errorMessage(error) },
        });
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getFilesForPreview = (data) => {
  return (dispatch) => {
    dispatch({
      type: GET_FILES_FOR_PREVIEW_LIST,
      payload: {
        message: null,
        next: false,
        apiError: false,
        apiSuccess: false,
        loader: true,
      },
    });
    service
      .getFilesForPreviewList(data)
      .then((res) => {
        dispatch({
          type: GET_FILES_FOR_PREVIEW_LIST,
          payload: {
            message: null,
            next: false,
            data: res.data,
            apiError: false,
            apiSuccess: false,
            loader: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_FILES_FOR_PREVIEW_LIST,
          payload: {
            data: [],
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const ClearGetFilesForPreviewApiStatus = (CLEAR_API_STATUS) => {
  return (dispatch) => {
    dispatch({
      type: GET_FILES_FOR_PREVIEW_LIST,
      payload: {},
    });
  };
};

export const getTasksList = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    dispatch({
      type: GET_TASKS_DATA,
      payload: {
        projects: [],
        batches: [],
        total_count: 0,
      },
    });
    service
      .getTasksList(data)
      .then((res) => {
        dispatch({
          type: GET_TASKS_DATA,
          payload: res?.data?.data,
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            loader: false,
            next: true,
            apiSuccess: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getDrugTypeListBatchAndUserNames = () => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { message: "", loader: true, next: false },
    });
    service
      .getDrugTypeListBatchAndUserNames()
      .then((res) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            loader: false,
            next: false,
            apiSuccess: true,
          },
        });
        dispatch({
          type: PRODUCT_TYPE_BATCH_NAME_USER_NAME,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const clearDashboardTilesApiStatus = () => {
  return (dispatch) => {
    dispatch({
      type: DASHBOARD_TILES_API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus },
    });
  };
};

export const getDashboardLogsTilesDta = (data) => {
  return (dispatch) => {
    dispatch({
      type: DASHBOARD_TILES_API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getDashboardLogsTilesDta(data)
      .then((res) => {
        dispatch({
          type: DASHBOARD_TILES_API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            loader: false,
            next: false,
            apiSuccess: true,
          },
        });
        dispatch({
          type: DASHBOARD_LOG_TILES_DATA,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: DASHBOARD_TILES_API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getBatchNames = (id) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { message: "", loader: true, next: false },
    });
    service
      .getBatchNames(id)
      .then((res) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            loader: false,
            next: false,
            apiSuccess: true,
          },
        });
        dispatch({
          type: BATCH_NAMES,
          payload: res.data.data?.batches_list,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });

        // dispatch({
        //   type: BATCH_NAMES,
        //   payload: [
        //     {
        //       id: 489,
        //       name: "b1",
        //     },
        //     {
        //       id: 501,
        //       name: "b1",
        //     },
        //     {
        //       id: 500,
        //       name: "b3",
        //     },
        //     {
        //       id: 499,
        //       name: "b4",
        //     },
        //     {
        //       id: 498,
        //       name: "b5",
        //     },
        //     {
        //       id: 496,
        //       name: "b6",
        //     },
        //     {
        //       id: 497,
        //       name: "b7",
        //     },
        //     {
        //       id: 495,
        //       name: "b8",
        //     },
        //     {
        //       id: 494,
        //       name: "b9",
        //     },
        //     {
        //       id: 493,
        //       name: "b10",
        //     },
        //   ],
        // });
      });
  };
};

export const getBatchesTilesOfProject = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { message: "", loader: true, next: false },
    });
    service
      .getBatchesTilesOfProject(data)
      .then((res) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            loader: false,
            next: false,
            apiSuccess: true,
          },
        });
        dispatch({
          type: BATCH_TILES_DATA,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getBatchDocuments = (batchId) => {
  return (dispatch) => {
    service
      .getBatchDocuments(batchId)
      .then((res) => {
        dispatch({
          type: BATCH_DOCUMENTS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getBatchLogFiltersData = (batchId) => {
  return (dispatch) => {
    service
      .getBatchLogFiltersData(batchId)
      .then((res) => {
        dispatch({
          type: GET_BATCH_LOGS_FILTERS_DATA,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getBatchParameters = (batchId) => {
  return (dispatch) => {
    service
      .getBatchParameters(batchId)
      .then((res) => {
        dispatch({
          type: BATCH_PARAMETERS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getBatchOrProjectLogs = (id, type, batchDetailsFilters) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_GET_LOGS,
      payload: { message: "", loader: true, next: false },
    });
    dispatch({
      type: BATCH_LOGS,
      payload: [],
    });
    service
      .getBatchOrProjectLogs(id, type, batchDetailsFilters)
      .then((res) => {
        dispatch({
          type: API_STATUS_GET_LOGS,
          payload: {
            ...initialState?.apiStatus,
            loader: false,
            next: false,
            apiSuccess: true,
          },
        });
        dispatch({
          type: BATCH_LOGS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_GET_LOGS,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getTotalProjectsAndBatchesWithStatusCount = () => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getTotalProjectsAndBatchesWithStatusCount()
      .then((res) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            loader: false,
            next: false,
            apiSuccess: true,
          },
        });
        dispatch({
          type: GET_PROJECTS_AND_BATCHES_WITH_STATUS_COUNTS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getDrugProducts = () => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getDrugProducts()
      .then((res) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            loader: false,
            next: false,
            apiSuccess: true,
          },
        });
        dispatch({
          type: GET_DRUG_PRODUCTS,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getCountsPerDrugProducts = (productName) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getCountsPerDrugProducts(productName)
      .then((res) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            loader: false,
            next: false,
            apiSuccess: true,
          },
        });
        dispatch({
          type: GET_COUNTS_PER_DRUG_PRODUCTS,
          payload: res.data.data[0],
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getProjectsAndBatches = () => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getProjectsAndBatches()
      .then((res) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            loader: false,
            next: false,
            apiSuccess: true,
          },
        });
        dispatch({
          type: GET_PROJECT_AND_BATCHES,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const clearBatchStatus = () => {
  return (dispatch) => {
    dispatch({
      type: GET_BATCH_STATUS,
      payload: "",
    });
  };
};

export const getBatchStatusClear = () => {
  return (dispatch) => {
    dispatch({
      type: GET_BATCH_STATUS,
      payload: { batchStatus: "", batchName: "" },
    });
  };
};

export const getBatchStatus = (project, batch) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getBatchStatus(project, batch)
      .then((res) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            loader: false,
            next: false,
            apiSuccess: true,
          },
        });
        dispatch({
          type: GET_BATCH_STATUS,
          payload: { batchStatus: res.data.message, batchName: batch },
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_BATCH_STATUS,
          payload: { batchStatus: "", batchName: batch },
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getAllBatchTilesFilters = () => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getAllBatchTilesFilters()
      .then((res) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            loader: false,
            next: false,
            apiSuccess: true,
          },
        });
        dispatch({
          type: GET_BATCH_TILES_FILTERS_DATA,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getAllBatchTiles = (selectedFilterData) => {
  return (dispatch) => {
    dispatch({
      type: GET_ALL_BATCH_TILES_API_STATUS,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getAllBatchTiles(selectedFilterData)
      .then((res) => {
        dispatch({
          type: GET_ALL_BATCH_TILES_API_STATUS,
          payload: {
            ...initialState?.apiStatus,
            loader: false,
            next: false,
            apiSuccess: true,
          },
        });
        dispatch({
          type: GET_BATCH_TILES_DATA,
          payload: res.data.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_ALL_BATCH_TILES_API_STATUS,
          payload: {
            ...initialState.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};

export const getDataForExport = (data) => {
  return (dispatch) => {
    service
      .getPdfLink(data)
      .then((res) => {
        dispatch({
          type: GET_LOG_PDF_URL,
          payload: {
            url: res?.data,
            loader: false,
            apiError: false,
            message: "",
          },
        });

        console.log("success");
      })
      .catch((error) => {
        dispatch({
          type: GET_LOG_PDF_URL,
          payload: {
            url: "",
            loader: false,
            apiError: true,
            message: error?.message,
          },
        });
        console.log("error");
      });
  };
};

export const clearUrlData = () => {
  return (dispatch) => {
    dispatch({
      type: GET_LOG_PDF_URL,
      payload: { url: "", loader: false, apiError: false, message: "" },
    });
  };
};

export const getOutPutUrl = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS_MASTER,
      payload: { ...initialState?.apiStatus, loader: true },
    });
    service
      .getManageOutputUrl(data)
      .then((res) => {
        dispatch({
          type: GET_OUT_PUT_URL,
          payload: res.data.data,
          loader: false,
        });
        dispatch({
          type: API_STATUS_MASTER,
          payload: { ...initialState?.apiStatus, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS_MASTER,
          payload: {
            ...initialState?.apiStatus,
            message: errorMessage(error),
            loader: false,
            next: false,
            apiError: true,
          },
        });
      });
  };
};
